import { useLangStore, type Lang } from '../store/langStore';

// ─────────────────────────────────────────────────────────────────────────────
// Translation dictionary
// ─────────────────────────────────────────────────────────────────────────────

export const TRANSLATIONS: Record<Lang, Record<string, string>> = {
  no: {
    // ── Nav / shared ───────────────────────────────────────────────────────
    'nav.login':       'Logg inn',
    'nav.get_started': 'Kom i gang',
    'nav.home':        'Hjem',
    'nav.library':     'Bibliotek',
    'nav.parents':     'Foreldre',

    // ── Landing hero ───────────────────────────────────────────────────────
    'hero.title_prefix': 'Hvert barn er laget av',
    'hero.subtitle':
      'En undringmaskin for barn i alderen 4–16. Levende STEAM-leksjoner som begynner med forundring, bygger gjennom kunnskap, og alltid slutter med et åpent spørsmål.',
    'hero.cta1':        'Start gratis i dag',
    'hero.cta2':        'Se en leksjon',
    'hero.disclaimer':  'Ingen kredittkort nødvendig. Gratis plan inkludert.',

    // ── Sagan ──────────────────────────────────────────────────────────────
    'sagan.quote': 'Et sted venter noe utrolig på å bli kjent.',

    // ── Four movements ─────────────────────────────────────────────────────
    'movements.heading': 'Hva om Carl Sagan bygde en skole?',
    'movements.sub':
      'Hver leksjon på Good Atoms følger fire bevegelser — inspirert av verdens største vitenskapskommunikatør.',
    'move1.sub':   'Kroken',
    'move1.title': 'Undring',
    'move1.desc':
      'Hver leksjon åpner med et spørsmål som skaper en ekte luke mellom det barnet vet og det de er i ferd med å oppdage.',
    'move2.sub':   'Broen',
    'move2.title': 'Grunn',
    'move2.desc':
      'Konseptet knyttes til barnets umiddelbare verden — kroppen, hjemmet, lørdagen, telefonen.',
    'move3.sub':   'Strengheten',
    'move3.title': 'Bygg',
    'move3.desc':
      'Ordentlig terminologi, bearbeidede eksempler, stigende kompleksitet — i NCERT og MIT-standard.',
    'move4.sub':   'Døren',
    'move4.title': 'Åpent',
    'move4.desc':
      'Hvert leksjon avsluttes med et spørsmål leksjonen ikke svarte. Barnet forlater mer nysgjerrig enn da de kom.',

    // ── Subjects ───────────────────────────────────────────────────────────
    'subjects.heading': 'Seks fag. Uendelig nysgjerrighet.',
    'subjects.sub':
      'Hvert fag har sin egen fargeidentitet og fagspesifikke pedagogikk.',

    // ── Hybrid learning ────────────────────────────────────────────────────
    'hybrid.tag':     'Hybrid læring',
    'hybrid.heading': 'Skjerm og papir.\nAlltid begge.',
    'hybrid.body':
      'Forskning er entydig: håndskrift styrker hukommelsen. Hvert Good Atoms-leksjon er bygget som et diptykk — en digital interaktiv del og et trykt A4-arbeidsark som venter på skriveren din.',
    'hybrid.feat1': 'Interaktive leksjoner med animerte forklaringer',
    'hybrid.feat2': 'Nedlastbart A4-arbeidsark til hvert leksjon',
    'hybrid.feat3': 'Ukentlig Prnt Pack — en PDF med ukets leksjoner',
    'hybrid.feat4': 'Aktivitetskort for fysisk bygging og utforskning',

    // ── Testimonials ───────────────────────────────────────────────────────
    'testimonials.heading': 'Fra norske familier',

    // ── Pricing ────────────────────────────────────────────────────────────
    'pricing.heading': 'Enkel prising',
    'pricing.sub':     'Velg det som passer familien din.',
    'plan.free.name':       'Gratis',
    'plan.free.period':     '/ måned',
    'plan.free.feat1':      '1 aktiv sti',
    'plan.free.feat2':      '2 leksjoner / uke',
    'plan.free.feat3':      'Grunnleggende arbeidsark',
    'plan.free.feat4':      '1 barneprofil',
    'plan.free.cta':        'Kom i gang',
    'plan.free.note':       'Gratis plan inkludert — 2 leksjoner/uke, ingen kredittkort nødvendig.',
    'plan.premium.name':    '1 barn',
    'plan.premium.period':  'kr / måned',
    'plan.premium.feat1':   'Ubegrenset leksjoner',
    'plan.premium.feat2':   'Alle fag',
    'plan.premium.feat3':   'Ukentlig Prnt Pack',
    'plan.premium.feat4':   '1 barneprofil',
    'plan.premium.feat5':   'Interaktive spill',
    'plan.premium.cta':     'Start for 99 kr',
    'plan.home.name':       '2 barn',
    'plan.home.period':     'kr / måned',
    'plan.home.feat1':      'Ubegrenset leksjoner',
    'plan.home.feat2':      'Alle fag',
    'plan.home.feat3':      'Ukentlig Prnt Pack',
    'plan.home.feat4':      '2 barneprofiler',
    'plan.home.cta':        'Start for 149 kr',
    'plan.family.name':     'Familie+',
    'plan.family.period':   'kr / måned',
    'plan.family.feat1':    'Ubegrenset leksjoner',
    'plan.family.feat2':    'Alle fag',
    'plan.family.feat3':    'Ukentlig Prnt Pack',
    'plan.family.feat4':    '3+ barneprofiler',
    'plan.family.feat5':    'Læringsrapport per barn',
    'plan.family.cta':      'Start for 189 kr',

    // ── CTA / Footer ───────────────────────────────────────────────────────
    'cta.heading':  'Tenn nysgjerrigheten deres.',
    'cta.body':
      'Hvert barn som åpner Good Atoms bør føle, etter sin første leksjon, at verden er større og mer interessant enn de trodde.',
    'cta.btn':       'Start gratis i dag',
    'footer.made':   'Vi er laget av stjernestøv — hold deg nysgjerrig. · Good Atoms Oslo 2026',
    'footer.privacy':'Personvern',
    'footer.terms':  'Vilkår',

    // ── Child home ─────────────────────────────────────────────────────────
    'greeting.morning':   'God morgen',
    'greeting.afternoon': 'God ettermiddag',
    'greeting.evening':   'God kveld',
    'streak.days':        'dager',
    'streak.row':         'dager på rad!',
    'home.screen_time':   'Bare 15 min fokusert læring — ikke passivt skjermtid',
    'streak.msg.default': 'Bra jobbet! Kom tilbake i morgen! 🌱',
    'streak.msg.3':       'Du er på vei! Hold det gående! 🔥',
    'streak.msg.7':       'En hel uke! Helt fantastisk! 🏆',
    'streak.msg.14':      'To uker! Du er uslåelig! 💎',
    'streak.msg.30':      'En hel måned! Du er en legende! 👑',
    'streak.cta':         'Fortsett! →',
    'today.label':        '📚 Dagens leksjon',
    'today.start':        'Start leksjon →',
    'today.movements':    '4 bevegelser',
    'done.title':         'Bra jobbet i dag!',
    'done.sub':           'Du fullførte din sti. Men læring stopper aldri!',
    'path.label':         'Din sti',
    'explore.label':      '🚀 Lyst til å lære mer?',
    'explore.surprise':   'Overrask meg!',
    'explore.surprise_sub':
      'Et tilfeldig leksjon fra et ukjent emne. Nysgjerrighet uten grenser.',
    'explore.start':      'Start →',
    'crew.label':         'Møt gjengen din',
    'pathways.label':     '🗺️ Alle stier',
    'pathways.active':    'Aktiv',
    'pathways.lessons':   'leksjoner',

    // ── Lesson experience ──────────────────────────────────────────────────
    'lesson.loading':      'Henter leksjon...',
    'lesson.home':         '← Hjem',
    'section1':            'Undring',
    'section2':            'Grunnlag',
    'section3':            'Bygg',
    'section4':            'Øvelse',
    'section5':            'Åpent spørsmål',
    'context':             'Kontekst:',
    'definition':          'Definisjon',
    'key_terms':           'Nøkkelbegreper',
    'example':             'Eksempel',
    'task':                'Oppgave',
    'answer':              'Svar',
    'explanation':         'Forklaring',
    'questions':           'spørsmål',
    'check_answer':        'Sjekk svaret ✓',
    'practice.write_answer': 'Skriv svaret ditt her …',
    'practice.show_answer':  'Vis fasit',
    'practice.self_right':   'Jeg fikk det til ✓',
    'practice.self_wrong':   'Ikke ennå',
    'practice.try_again':    'Prøv en gang til!',
    'interactive.label':        'Prøv selv',
    'interactive.play':         'Spill nå!',
    'interactive.playAgain':    'Spill igjen ↺',
    'interactive.start':        'Start aktiviteten',
    'interactive.openExternal': 'Åpne i ny fane',
    'interactive.provider':     'Fra {n} — åpnes her på siden',
    'interactive.tried':        'Jeg prøvde det! ✓',
    'interactive.done':         'Utforsket!',
    'interactive.tryTitle':     'Prøv selv!',
    'interactive.lockedTitle':  'Oppgavene venter',
    'interactive.locked':       'Prøv den interaktive aktiviteten først — så låses oppgavene opp!',
    'need_help':           '🤔 Trenger hjelp?',
    'hide_help':           'Skjul hjelp ✕',
    'correct':             'Riktig! 🎉',
    'incorrect':           'Ikke helt riktig.',
    'hands_on':            'Hands-on aktivitet',
    'you_need':            'Du trenger',
    'look_for':            'Hva du ser etter',
    'approx_time':         'Ca. {n} minutter',
    'complete_lesson':     'Fullfør leksjonen 🎉',

    // ── Help system ────────────────────────────────────────────────────────
    'help.title':       'Trenger du hjelp? 🤔',
    'help.solve_it':    'Jeg vil løse det!',
    'help.step_by_step':'Vis meg steg for steg',
    'help.ask_adult':   'Spør en voksen',
    'help.teacher':     'Foreldre eller lærer',
    'help.together':    'Vi løser det sammen!',
    'help.next_step':   'Neste steg →',
    'help.understood':  'Skjønner du det nå? 🎉 Prøv å svare!',
    'help.not_sure':    'Ikke sikker? Det er helt greit! 💡',
    'help.ask_parent':
      'Spør foreldrene dine eller læreren din — de elsker når du stiller spørsmål.',
    'help.curious':     'Vær alltid nysgjerrig! 🌟',

    // ── Mascot contextual helper (opt-in "good Clippy") ─────────────────────
    'mascotHelp.nudge':   'Vil du ha et hint?',
    'mascotHelp.yes':     'Ja, hjelp meg',
    'mascotHelp.no':      'Nei takk',
    'mascotHelp.close':   'Lukk hjelperen',
    'mascotHelp.ask':     'Be om et hint',
    'mascotHelp.revoice': 'Spennende gjetning! Skal vi se på den sammen?',
    // Process praise (Khan-verified pattern): praise the ACTION, never a generic "Jippi!"
    'mascotHelp.praise.young.0':    'Du prøvde en idé og sjekket den! 🔍',
    'mascotHelp.praise.young.1':    'Du leste nøye og fant svaret selv! ⭐',
    'mascotHelp.praise.youngRetry': 'Du ga ikke opp — du prøvde igjen og fikk det til! 💪',
    'mascotHelp.praise.older.0':    'Du testet ideen din — den holdt.',
    'mascotHelp.praise.older.1':    'Resonnementet ditt ledet deg til riktig svar.',
    'mascotHelp.praise.olderRetry': 'Du justerte hypotesen og prøvde igjen. Sånn jobber forskere.',

    // ── Lesson complete ────────────────────────────────────────────────────
    'complete.title':       'Leksjon fullført!',
    'complete.practice':    'Øvelsesspørsmål',
    'complete.of':          'av',
    'complete.perfect':     'Perfekt! 🌟',
    'complete.dinner':      'Middagsbordspørsmål',
    'complete.worksheet':   'Last ned arbeidsark',
    'complete.back':        'Tilbake til hjem',

    // ── Bonus lessons ─────────────────────────────────────────────────────
    'bonus.cta':               'Fortsett å lære',
    'bonus.subtitle':          'En ny oppgave er klar til deg',
    'bonus.loading':           'Klargjør...',
    'bonus.cap_reached_title': 'Fantastisk jobbet!',
    'bonus.cap_reached_body':  'La hjernen hvile — prøv den praktiske aktiviteten nå.',

    // ── Mascot quips ──────────────────────────────────────────────────────
    'quip.hex.0':     'Hei! Jeg er Hex! 🔢',
    'quip.hex.1':     'Visste du at bier lager sekskanter? 🐝',
    'quip.hex.2':     'Tall er overalt! ✨',
    'quip.hex.3':     'Trykk meg igjen! 😄',
    'quip.hex.4':     'Pi = 3.14159… og mer! 🥧',
    'quip.blobby.0':  'Hei! Jeg er Blobby! 🔬',
    'quip.blobby.1':  'Det finnes 8,7 millioner dyrearter! 🦋',
    'quip.blobby.2':  'Vann kan bli is, damp og væske! 💧',
    'quip.blobby.3':  'Trykk meg igjen! 🧪',
    'quip.blobby.4':  'Hjernen din er 73% vann! 🧠',
    'quip.pixel.0':   'Hei! Jeg er Pixel! 💻',
    'quip.pixel.1':   '01001000 = bokstaven H! 0️⃣1️⃣',
    'quip.pixel.2':   'Den første buggen var en ekte insekt! 🪲',
    'quip.pixel.3':   'Trykk meg igjen! 🤖',
    'quip.pixel.4':   'Internett ble skapt i 1989! 🌐',
    'quip.cogs.0':    'Hei! Jeg er Cogs! ⚙️',
    'quip.cogs.1':    'Trekanter er den sterkeste formen! 📐',
    'quip.cogs.2':    'Den første broen er 5000 år gammel! 🌉',
    'quip.cogs.3':    'Trykk meg igjen! 🔧',
    'quip.cogs.4':    'Vann kan løfte tunge skip! ⛵',
    'quip.blossom.0': 'Hei! Jeg er Blossom! 🎨',
    'quip.blossom.1': 'Farger kan endre humøret ditt! 🌈',
    'quip.blossom.2': 'Musikk aktiverer hele hjernen! 🎵',
    'quip.blossom.3': 'Trykk meg igjen! 🌸',
    'quip.blossom.4': 'Kunst er over 45 000 år gammel! 🦣',
    'quip.sprout.0':  'Hei! Jeg er Sprout! 🌳',
    'quip.sprout.1':  'Trær kommuniserer gjennom røttene! 🌱',
    'quip.sprout.2':  'En dag absorberer jeg 100 liter vann! 💧',
    'quip.sprout.3':  'Trykk meg igjen! 🍃',
    'quip.sprout.4':  'Noen trær er over 5000 år gamle! 🌲',

    // ── Onboarding — child profile ──────────────────────────────────────────
    'onboard.step':             'Steg {n} av 4',
    'onboard.s1.heading':       'Hvem lærer?',
    'onboard.s1.sub':           'La oss bli kjent med barnet ditt.',
    'onboard.s1.avatarLabel':   'Velg en avatar',
    'onboard.s1.nameLabel':     'Barnets navn',
    'onboard.s1.namePh':        'F.eks. Emma',
    'onboard.s1.ageLabel':      'Alder',
    'onboard.s1.ageUnit':       'år',
    'onboard.s1.ageMin':        '4 år',
    'onboard.s1.ageMax':        '16 år',
    'onboard.s2.heading':       'Hva er {n} nysgjerrig på?',
    'onboard.s2.sub':           'Velg ett eller flere interesseområder.',
    'onboard.s2.selected':      '✓ Valgt',
    'onboard.s3.heading':       'Leksjonsspråk',
    'onboard.s3.sub':           'Velg hvilket språk {n} vil lære på.',
    'onboard.s3.selected':      '✓ Valgt',
    'onboard.s3.age':           '{n} år',
    'onboard.lang.no':          'Norsk',
    'onboard.lang.no.sub':      'Bokmål',
    'onboard.lang.en':          'Engelsk',
    'onboard.lang.en.sub':      'English',
    'onboard.back':             'Tilbake',
    'onboard.next':             'Neste steg →',
    'onboard.finish':           'Fortsett til stier →',

    // ── Onboarding — Blobby guide messages ─────────────────────────────────
    'onboard.guide.hello':      'Hei! Hva heter du? 😊',
    'onboard.guide.greet':      'Hyggelig, {n}! 👋',
    'onboard.guide.curious':    'Hva er du nysgjerrig på? 🔬',
    'onboard.guide.more':       'Bra start! Velg gjerne flere! ✨',
    'onboard.guide.wow':        'Du er veldig nysgjerrig! 🌟',
    'onboard.guide.lang':       'Nesten ferdig! Velg språk! 🌍',

    // ── Onboarding — interest labels ────────────────────────────────────────
    'interest.science':         'Vitenskap',
    'interest.making':          'Ingeniørfag',
    'interest.numbers':         'Tall',
    'interest.stories':         'Fortellinger',
    'interest.nature':          'Natur',
    'interest.technology':      'Teknologi',

    // ── Onboarding — pathway suggestion ────────────────────────────────────
    'pathway.fallback':         'barnet ditt',
    'pathway.heading':          'Hei, {n}! Hvilken sti starter vi med?',
    'pathway.sub':              'Velg en sti for å komme i gang. Du kan alltid bytte eller legge til flere stier senere.',
    'pathway.sub.spark':        'Disse stiene er bygget for Gnist-nivå (4–6 år). Utforsk STEAM gjennom lek og nysgjerrighet!',
    'pathway.sub.explorer':     'Disse stiene er bygget for Utforsker-nivå (7–9 år). Dykk dypere inn i realfag og skaperkraft!',
    'pathway.sub.builder':      'Disse stiene er bygget for Bygger-nivå (10–12 år). Lær å tenke som en forsker og ingeniør!',
    'pathway.sub.challenger':   'Disse stiene er bygget for Utfordrer-nivå (13–16 år). Ta på deg de store spørsmålene i vitenskap og teknologi!',
    'pathway.level.1':          'Nybegynner',
    'pathway.level.2':          'Middels',
    'pathway.level.3':          'Avansert',
    'pathway.lessons':          '{n} leksjoner',
    'pathway.weeks':            'Ca. {n} uker',
    'pathway.age':              'Alder {n}',
    'pathway.footer':           'Alle stier inkluderer leksjoner med de fire Sagan-bevegelsene, interaktive komponenter, og nedlastbare arbeidsark.',

    // ── Child home — missing keys ───────────────────────────────────────────
    'games.label':              '🎮 Interaktive spill',
    'games.all':                'Se alle spill →',

    // ── Lesson resume banner ────────────────────────────────────────────────
    'resume.progress':          'spørsmål besvart',
    'resume.continue_q':        'Vil du fortsette der du slapp? 🔖',
    'resume.yes':               'Fortsett →',
    'resume.fresh':             'Start på nytt',

    // ── Subject labels (used in SubjectBadge) ──────────────────────────────
    'subject.mathematics':      'Matematikk',
    'subject.science':          'Naturfag',
    'subject.technology':       'Teknologi',
    'subject.engineering':      'Ingeniørfag',
    'subject.arts':             'Kunst',
    'subject.futureskills':     'Fremtidsferdigheter',

    // ── Landing page demo section ───────────────────────────────────────────
    'demo.tag':       'Se et ekte leksjon',
    'demo.heading':   'Prøv en ekte Good Atoms-leksjon',
    'demo.sub':       'Velg et fag og les bevegelse 1 av et ekte leksjon — ingen konto nødvendig.',
    'demo.move1':     'Bevegelse 1 · Undring',
    'demo.bridge':    'Virkelig verden:',
    'demo.locked':    '+ 3 bevegelser tilgjengelig etter gratis registrering',
    'demo.cta':       'Start dette leksjonen gratis →',
    'demo.nocredit':  'Ingen kredittkort nødvendig',

    // ── Achievement badges ──────────────────────────────────────────────────
    'badges.label':                  '🏅 Dine merker',
    'badge.new':                     'Nytt merke!',
    'badge.unlock_cta':              'Supert! →',
    'badge.first_step.name':         'Første steg',
    'badge.first_step.desc':         'Du fullførte din første leksjon. Reisen begynner!',
    'badge.eager_reader.name':       'Ivrig leser',
    'badge.eager_reader.desc':       'Du har fullført 5 leksjoner. Du er på vei!',
    'badge.knowledge_rocket.name':   'Kunnskap raketteres',
    'badge.knowledge_rocket.desc':   '10 leksjoner fullført. Du tar av! 🚀',
    'badge.perfect_score.name':      'Perfekt!',
    'badge.perfect_score.desc':      'Alle riktige svar i ett leksjon. Utrolig!',
    'badge.on_fire.name':            'Tre i strekk',
    'badge.on_fire.desc':            '3 dager på rad. Du er varm!',
    'badge.weekly_warrior.name':     'Ukekjempe',
    'badge.weekly_warrior.desc':     '7 dager på rad. En hel uke med læring!',
    'badge.two_week_titan.name':     'To-ukers titan',
    'badge.two_week_titan.desc':     '14 dager på rad. Du er uslåelig!',
    'badge.monthly_master.name':     'Månedsmester',
    'badge.monthly_master.desc':     '30 dager på rad. Du er en legende!',
    'badge.explorer.name':           'Utforsker',
    'badge.explorer.desc':           'Du har prøvd leksjoner i to forskjellige fag!',
    'badge.path_complete.name':      'Sti fullført',
    'badge.path_complete.desc':      'Du fullførte en hel sti. Imponerende!',

    // ── Parent dashboard ───────────────────────────────────────────────────
    'parent.board':               'Good Atoms Board',
    'parent.dashboard':           'Foreldredashbord',
    'parent.last_active':         'Sist aktiv',
    'parent.today':               'I dag',
    'parent.yesterday':           'I går',
    'parent.days_ago':            '{n} dager siden',
    'parent.child_view':          'Barnets visning →',
    'parent.activity_title':      '7-dagers aktivitet',
    'parent.minutes_per_day':     'minutter / dag',
    'parent.subjects_title':      'Fagfordeling',
    'parent.lesson_singular':     'leksjon',
    'parent.lesson_plural':       'leksjoner',
    'parent.pathway_title':       'Stifremgang',
    'parent.pathway_of':          'av',
    'parent.completed_title':     'Fullførte leksjoner',
    'parent.worksheet':           'Arbeidsark',
    'parent.add_child':           'Legg til barn',
    'parent.settings':            'Innstillinger',

    'continue.next_lesson':       'Neste leksjon →',
    'continue.explore':           'Utforsk mer',

    'empty.title':                'Flere leksjoner er på vei',
    'empty.sub':                  'Vi lager noe nytt til deg. Prøv et spill imens!',

    'printpacks.title':           'Utskriftspakke',
    'printpacks.subtitle':        'Ukentlige utskriftspakker for barnet ditt',
    'printpacks.card_title':      'Ukentlig utskriftspakke',
    'printpacks.card_body':       'Hver søndag genereres en PDF med ukets arbeidsark, et prosjektkort, middagsbordspørsmål og en foreldrebriefing. Tilgjengelig på Premium.',
    'printpacks.upgrade':         'Oppgrader til Premium',
    'printpacks.back':            '← Tilbake',
    'parent.upgrade.badge':       'Betalt plan',
    'parent.upgrade.title':       'Lås opp hele Good Atoms',
    'parent.upgrade.subtitle':    'Ubegrenset leksjoner · Alle fag · Ukentlig Prnt Pack',
    'parent.upgrade.from':        'fra 99 kr',
    'parent.upgrade.per_month':   '/ måned',
    'parent.upgrade.feat1':       'Ubegrenset leksjoner og stier',
    'parent.upgrade.feat2':       'Ukentlig Prnt Pack (PDF-arbeidsark)',
    'parent.upgrade.feat3':       'Opptil 3+ barneprofiler',
    'parent.upgrade.cta':         'Se alle planer →',
    'parent.stat.lessons':        'Leksjoner fullført',
    'parent.stat.minutes':        'Minutter lært',
    'parent.stat.streak':         'Dager på rad',
    'parent.stat.path':           'Aktiv sti',
    'day.0': 'Man', 'day.1': 'Tir', 'day.2': 'Ons', 'day.3': 'Tor',
    'day.4': 'Fre', 'day.5': 'Lør', 'day.6': 'Søn',

    // ── Settings page ──────────────────────────────────────────────────────
    'settings.title':              'Innstillinger',
    'settings.subtitle':           'Konto og preferanser',
    'settings.email':              'E-post',
    'settings.subscription':       'Abonnement',
    'settings.language':           'Språk',
    'settings.accessibility':      'Tilgjengelighet',
    'settings.reduce_motion':      'Reduser bevegelse',
    'settings.reduce_motion_desc': 'Slår av animasjoner i hele appen. Bra for barn med vestibulære lidelser, ADHD eller lysømfintlighet.',
    'settings.reduce_motion_on':   '✓ Animasjoner er deaktivert',
    'settings.motion_on':          'Reduser bevegelse på',
    'settings.motion_off':         'Reduser bevegelse av',
    'settings.logout':             'Logg ut',
    'settings.plan.free':          'Gratis',
    'settings.plan.premium':       '1 barn',
    'settings.plan.homeschool':    '2 barn',
    'settings.plan.family':        'Familie+',
    'settings.lang.no':            'Norsk (Bokmål)',
    'settings.lang.en':            'Engelsk',

    // ── Worksheet page ─────────────────────────────────────────────────────
    'worksheet.back':       '← Tilbake',
    'worksheet.download':   '⬇ Last ned PDF',
    'worksheet.print':      '🖨 Skriv ut',
    'worksheet.home':       'Hjem',
    'worksheet.name':       'Navn:',
    'worksheet.date':       'Dato:',
    'worksheet.age':        'Alder {n}',
    'worksheet.family':     'Familieaktivitet',
    'worksheet.forGrownUps':    'For voksne',
    'worksheet.childLearned':   'Hva barnet har lært',
    'worksheet.misconceptions': 'Vanlige misforståelser',
    'worksheet.nextTime':       'Neste gang',
    'worksheet.sources':    'Kilder:',
    'worksheet.not_found':  'Leksjon ikke funnet.',

    // ── Mestringsmerker (parent dashboard topic badges) ─────────────────────
    'parent.badges.title':        'Mestringsmerker',
    'parent.badges.subtitle':     '{n} har mestret',
    'parent.badges.empty':        'Fullfør den første leksjonen for å tjene et merke!',
    'parent.badges.email_upsell': '📧 Oppgrader for feirings-e-post',
    'parent.celebrate.title':     'Feir med {n}!',

    // ── Library books (parent dashboard) ────────────────────────────────────
    'parent.library.title':    '📚 Anbefalte bøker fra biblioteket',
    'parent.library.subtitle': 'Basert på alder og fag',
    'parent.library.free':     '✓ Gratis å låne',
    'parent.library.find':     'Finn →',

    // ── Consent ───────────────────────────────────────────────────────────────
    'consent.heading':          'Samtykke',
    'consent.body':             'Good Atoms behandler barnets navn, alder og læringsdata for å tilpasse leksjoner.',
    'consent.privacy_link':     'Les vår personvernerklæring',
    'consent.checkbox_before':  'Jeg bekrefter at jeg er forelder/foresatt og samtykker til at Good Atoms behandler barnets læringsdata som beskrevet i vår ',
    'consent.checkbox_link':    'personvernerklæring',
    'consent.checkbox_after':   '.',
    'consent.checkbox':         'Jeg bekrefter at jeg er forelder/foresatt og samtykker til at Good Atoms behandler barnets læringsdata som beskrevet i vår personvernerklæring.',
    'consent.required':         'Du må samtykke for å fortsette.',

    // ── Session timeout ──────────────────────────────────────────────────────
    'session.warning':          'Er du der fortsatt? Økten din utløper om {n} minutter av sikkerhetshensyn.',
    'session.stay':             'Forbli innlogget',

    // ── Undring (content section, formerly "Blog") ───────────────────────────
    'blog.title':               'Undring',
    'blog.hero':                'Undring — fordi alle store oppdagelser starter med et spørsmål',
    'blog.subtitle':            'STEAM-læring, realfag, kreativitet og digitale tips for foreldre. Fra Good Atoms.',
    'blog.all':                 'Alle',
    'blog.featured':            'Fremhevet',
    'blog.no_posts':            'Ingen artikler ennå. Kom tilbake snart!',
    'blog.read_time':           'min lesetid',
    'blog.also_read':           'Les også',
    'blog.back':                '← Tilbake til Undring',
    'blog.not_found':           'Artikkel ikke funnet',
    'blog.cta_title':           'Klar til å tenne nysgjerrigheten?',
    'blog.cta_body':            'Good Atoms er STEAM-læring som begynner med undring. Prøv gratis — ingen kredittkort nødvendig.',
    'blog.cta_button':          'Start gratis i dag',
    'blog.faq':                 'Ofte stilte spørsmål',
  },

  en: {
    // ── Nav / shared ───────────────────────────────────────────────────────
    'nav.login':       'Log in',
    'nav.get_started': 'Get started',
    'nav.home':        'Home',
    'nav.library':     'Library',
    'nav.parents':     'Parents',

    // ── Landing hero ───────────────────────────────────────────────────────
    'hero.title_prefix': 'Every child is made up of',
    'hero.subtitle':
      'A wonder machine for children aged 4–16. Vibrant STEAM lessons that begin with awe, build through knowledge, and always end with an open question.',
    'hero.cta1':        'Start for free today',
    'hero.cta2':        'See a lesson',
    'hero.disclaimer':  'No credit card required. Free plan included.',

    // ── Sagan ──────────────────────────────────────────────────────────────
    'sagan.quote': 'Somewhere, something incredible is waiting to be known.',

    // ── Four movements ─────────────────────────────────────────────────────
    'movements.heading': 'What if Carl Sagan built a school?',
    'movements.sub':
      'Every lesson on Good Atoms follows four movements — inspired by the world\'s greatest science communicator.',
    'move1.sub':   'The Hook',
    'move1.title': 'Wonder',
    'move1.desc':
      'Every lesson opens with a question that creates a genuine gap between what the child knows and what they are about to discover.',
    'move2.sub':   'The Bridge',
    'move2.title': 'Foundation',
    'move2.desc':
      'The concept is connected to the child\'s immediate world — their body, their home, their Saturday, their phone.',
    'move3.sub':   'The Strength',
    'move3.title': 'Build',
    'move3.desc':
      'Proper terminology, worked examples, rising complexity — at NCERT and MIT standard.',
    'move4.sub':   'The Door',
    'move4.title': 'Open',
    'move4.desc':
      'Every lesson ends with a question the lesson did not answer. The child leaves more curious than when they arrived.',

    // ── Subjects ───────────────────────────────────────────────────────────
    'subjects.heading': 'Six subjects. Infinite curiosity.',
    'subjects.sub':
      'Each subject has its own colour identity and subject-specific pedagogy.',

    // ── Hybrid learning ────────────────────────────────────────────────────
    'hybrid.tag':     'Hybrid learning',
    'hybrid.heading': 'Screen and paper.\nAlways both.',
    'hybrid.body':
      'Research is clear: handwriting strengthens memory. Every Good Atoms lesson is built as a diptych — an interactive digital part and a printed A4 worksheet waiting for your printer.',
    'hybrid.feat1': 'Interactive lessons with animated explanations',
    'hybrid.feat2': 'Downloadable A4 worksheet for every lesson',
    'hybrid.feat3': 'Weekly Prnt Pack — a PDF of the week\'s lessons',
    'hybrid.feat4': 'Activity cards for physical building and exploration',

    // ── Testimonials ───────────────────────────────────────────────────────
    'testimonials.heading': 'From Norwegian families',

    // ── Pricing ────────────────────────────────────────────────────────────
    'pricing.heading': 'Simple pricing',
    'pricing.sub':     'Choose what fits your family.',
    'plan.free.name':       'Free',
    'plan.free.period':     '/ month',
    'plan.free.feat1':      '1 active path',
    'plan.free.feat2':      '2 lessons / week',
    'plan.free.feat3':      'Basic worksheets',
    'plan.free.feat4':      '1 child profile',
    'plan.free.cta':        'Get started',
    'plan.free.note':       'Free plan included — 2 lessons/week, no credit card required.',
    'plan.premium.name':    '1 child',
    'plan.premium.period':  'kr / month',
    'plan.premium.feat1':   'Unlimited lessons',
    'plan.premium.feat2':   'All subjects',
    'plan.premium.feat3':   'Weekly Prnt Pack',
    'plan.premium.feat4':   '1 child profile',
    'plan.premium.feat5':   'Interactive games',
    'plan.premium.cta':     'Start for 99 kr',
    'plan.home.name':       '2 children',
    'plan.home.period':     'kr / month',
    'plan.home.feat1':      'Unlimited lessons',
    'plan.home.feat2':      'All subjects',
    'plan.home.feat3':      'Weekly Prnt Pack',
    'plan.home.feat4':      '2 child profiles',
    'plan.home.cta':        'Start for 149 kr',
    'plan.family.name':     'Family+',
    'plan.family.period':   'kr / month',
    'plan.family.feat1':    'Unlimited lessons',
    'plan.family.feat2':    'All subjects',
    'plan.family.feat3':    'Weekly Prnt Pack',
    'plan.family.feat4':    '3+ child profiles',
    'plan.family.feat5':    'Learning report per child',
    'plan.family.cta':      'Start for 189 kr',

    // ── CTA / Footer ───────────────────────────────────────────────────────
    'cta.heading':  'Ignite their curiosity.',
    'cta.body':
      'Every child who opens Good Atoms should feel, after their first lesson, that the world is bigger and more interesting than they thought.',
    'cta.btn':       'Start for free today',
    'footer.made':   'We are made of star-stuff — keep wondering. · Good Atoms Oslo 2026',
    'footer.privacy':'Privacy',
    'footer.terms':  'Terms',

    // ── Child home ─────────────────────────────────────────────────────────
    'greeting.morning':   'Good morning',
    'greeting.afternoon': 'Good afternoon',
    'greeting.evening':   'Good evening',
    'streak.days':        'days',
    'streak.row':         'days in a row!',
    'home.screen_time':   'Just 15 min of focused learning — not passive screen time',
    'streak.msg.default': 'Great work! Come back tomorrow! 🌱',
    'streak.msg.3':       "You're on fire! Keep it going! 🔥",
    'streak.msg.7':       'A whole week! Amazing! 🏆',
    'streak.msg.14':      'Two weeks! You\'re unstoppable! 💎',
    'streak.msg.30':      'A whole month! You\'re a legend! 👑',
    'streak.cta':         'Keep going! →',
    'today.label':        '📚 Today\'s lesson',
    'today.start':        'Start lesson →',
    'today.movements':    '4 movements',
    'done.title':         'Great job today!',
    'done.sub':           'You completed your path. But learning never stops!',
    'path.label':         'Your path',
    'explore.label':      '🚀 Want to learn more?',
    'explore.surprise':   'Surprise me!',
    'explore.surprise_sub':
      'A random lesson from an unknown topic. Curiosity without limits.',
    'explore.start':      'Start →',
    'crew.label':         'Meet your crew',
    'pathways.label':     '🗺️ All paths',
    'pathways.active':    'Active',
    'pathways.lessons':   'lessons',

    // ── Lesson experience ──────────────────────────────────────────────────
    'lesson.loading':      'Loading lesson...',
    'lesson.home':         '← Home',
    'section1':            'Wonder',
    'section2':            'Foundation',
    'section3':            'Build',
    'section4':            'Practice',
    'section5':            'Open Question',
    'context':             'Context:',
    'definition':          'Definition',
    'key_terms':           'Key Concepts',
    'example':             'Example',
    'task':                'Task',
    'answer':              'Answer',
    'explanation':         'Explanation',
    'questions':           'questions',
    'check_answer':        'Check answer ✓',
    'practice.write_answer': 'Write your answer here …',
    'practice.show_answer':  'Show the answer',
    'practice.self_right':   'I got it ✓',
    'practice.self_wrong':   'Not yet',
    'practice.try_again':    'Try once more!',
    'interactive.label':        'Try it',
    'interactive.play':         'Play now!',
    'interactive.playAgain':    'Play again ↺',
    'interactive.start':        'Start the activity',
    'interactive.openExternal': 'Open in a new tab',
    'interactive.provider':     'From {n} — opens right here on the page',
    'interactive.tried':        'I tried it! ✓',
    'interactive.done':         'Explored!',
    'interactive.tryTitle':     'Try it yourself!',
    'interactive.lockedTitle':  'The questions are waiting',
    'interactive.locked':       'Try the interactive activity first — then the questions unlock!',
    'need_help':           '🤔 Need help?',
    'hide_help':           'Hide help ✕',
    'correct':             'Correct! 🎉',
    'incorrect':           'Not quite right.',
    'hands_on':            'Hands-on activity',
    'you_need':            'You need',
    'look_for':            'What to look for',
    'approx_time':         'About {n} minutes',
    'complete_lesson':     'Complete lesson 🎉',

    // ── Help system ────────────────────────────────────────────────────────
    'help.title':       'Need help? 🤔',
    'help.solve_it':    'I want to solve it!',
    'help.step_by_step':'Show me step by step',
    'help.ask_adult':   'Ask an adult',
    'help.teacher':     'Parent or teacher',
    'help.together':    'We solve it together!',
    'help.next_step':   'Next step →',
    'help.understood':  'Get it now? 🎉 Try to answer!',
    'help.not_sure':    'Not sure? That\'s totally fine! 💡',
    'help.ask_parent':
      'Ask your parents or teacher — they love when you ask questions.',
    'help.curious':     'Always stay curious! 🌟',

    // ── Mascot contextual helper (opt-in "good Clippy") ─────────────────────
    'mascotHelp.nudge':   'Want a hint?',
    'mascotHelp.yes':     'Yes, help me',
    'mascotHelp.no':      'No thanks',
    'mascotHelp.close':   'Close the helper',
    'mascotHelp.ask':     'Ask for a hint',
    'mascotHelp.revoice': 'Interesting guess! Shall we look at it together?',
    // Process praise (Khan-verified pattern): praise the ACTION, never a generic "Yay!"
    'mascotHelp.praise.young.0':    'You tried an idea and checked it! 🔍',
    'mascotHelp.praise.young.1':    'You read carefully and found the answer yourself! ⭐',
    'mascotHelp.praise.youngRetry': "You didn't give up — you tried again and got it! 💪",
    'mascotHelp.praise.older.0':    'You tested your idea — it held.',
    'mascotHelp.praise.older.1':    'Your reasoning led you to the right answer.',
    'mascotHelp.praise.olderRetry': "You revised your hypothesis and tried again. That's how scientists work.",

    // ── Lesson complete ────────────────────────────────────────────────────
    'complete.title':       'Lesson complete!',
    'complete.practice':    'Practice questions',
    'complete.of':          'of',
    'complete.perfect':     'Perfect! 🌟',
    'complete.dinner':      'Dinner table question',
    'complete.worksheet':   'Download worksheet',
    'complete.back':        'Back to home',

    // ── Bonus lessons ─────────────────────────────────────────────────────
    'bonus.cta':               'Keep learning',
    'bonus.subtitle':          'A new lesson is ready for you',
    'bonus.loading':           'Getting ready...',
    'bonus.cap_reached_title': 'Amazing work!',
    'bonus.cap_reached_body':  'Let your brain rest — try the hands-on activity now.',

    // ── Mascot quips ──────────────────────────────────────────────────────
    'quip.hex.0':     'Hi! I\'m Hex! 🔢',
    'quip.hex.1':     'Did you know bees make hexagons? 🐝',
    'quip.hex.2':     'Numbers are everywhere! ✨',
    'quip.hex.3':     'Click me again! 😄',
    'quip.hex.4':     'Pi = 3.14159… and more! 🥧',
    'quip.blobby.0':  'Hi! I\'m Blobby! 🔬',
    'quip.blobby.1':  'There are 8.7 million animal species! 🦋',
    'quip.blobby.2':  'Water can be ice, steam and liquid! 💧',
    'quip.blobby.3':  'Click me again! 🧪',
    'quip.blobby.4':  'Your brain is 73% water! 🧠',
    'quip.pixel.0':   'Hi! I\'m Pixel! 💻',
    'quip.pixel.1':   '01001000 = the letter H! 0️⃣1️⃣',
    'quip.pixel.2':   'The first bug was a real insect! 🪲',
    'quip.pixel.3':   'Click me again! 🤖',
    'quip.pixel.4':   'The internet was created in 1989! 🌐',
    'quip.cogs.0':    'Hi! I\'m Cogs! ⚙️',
    'quip.cogs.1':    'Triangles are the strongest shape! 📐',
    'quip.cogs.2':    'The first bridge is 5000 years old! 🌉',
    'quip.cogs.3':    'Click me again! 🔧',
    'quip.cogs.4':    'Water can lift heavy ships! ⛵',
    'quip.blossom.0': 'Hi! I\'m Blossom! 🎨',
    'quip.blossom.1': 'Colours can change your mood! 🌈',
    'quip.blossom.2': 'Music activates your whole brain! 🎵',
    'quip.blossom.3': 'Click me again! 🌸',
    'quip.blossom.4': 'Art is over 45,000 years old! 🦣',
    'quip.sprout.0':  'Hi! I\'m Sprout! 🌳',
    'quip.sprout.1':  'Trees talk to each other through roots! 🌱',
    'quip.sprout.2':  'I absorb 100 litres of water a day! 💧',
    'quip.sprout.3':  'Click me again! 🍃',
    'quip.sprout.4':  'Some trees are over 5,000 years old! 🌲',

    // ── Onboarding — child profile ──────────────────────────────────────────
    'onboard.step':             'Step {n} of 4',
    'onboard.s1.heading':       "Who's learning?",
    'onboard.s1.sub':           "Let's get to know your child.",
    'onboard.s1.avatarLabel':   'Choose an avatar',
    'onboard.s1.nameLabel':     "Child's name",
    'onboard.s1.namePh':        'E.g. Emma',
    'onboard.s1.ageLabel':      'Age',
    'onboard.s1.ageUnit':       'years old',
    'onboard.s1.ageMin':        '4 years',
    'onboard.s1.ageMax':        '16 years',
    'onboard.s2.heading':       'What is {n} curious about?',
    'onboard.s2.sub':           'Choose one or more areas of interest.',
    'onboard.s2.selected':      '✓ Selected',
    'onboard.s3.heading':       'Lesson language',
    'onboard.s3.sub':           'Choose the language {n} will learn in.',
    'onboard.s3.selected':      '✓ Selected',
    'onboard.s3.age':           '{n} years old',
    'onboard.lang.no':          'Norwegian',
    'onboard.lang.no.sub':      'Bokmål',
    'onboard.lang.en':          'English',
    'onboard.lang.en.sub':      'English',
    'onboard.back':             'Back',
    'onboard.next':             'Next step →',
    'onboard.finish':           'Continue to paths →',

    // ── Onboarding — Blobby guide messages ─────────────────────────────────
    'onboard.guide.hello':      "Hi! What's your name? 😊",
    'onboard.guide.greet':      'Nice to meet you, {n}! 👋',
    'onboard.guide.curious':    'What are you curious about? 🔬',
    'onboard.guide.more':       'Great start! Pick some more! ✨',
    'onboard.guide.wow':        "You're very curious! 🌟",
    'onboard.guide.lang':       'Almost done! Choose your language! 🌍',

    // ── Onboarding — interest labels ────────────────────────────────────────
    'interest.science':         'Science',
    'interest.making':          'Engineering',
    'interest.numbers':         'Numbers',
    'interest.stories':         'Stories',
    'interest.nature':          'Nature',
    'interest.technology':      'Technology',

    // ── Onboarding — pathway suggestion ────────────────────────────────────
    'pathway.fallback':         'your child',
    'pathway.heading':          'Hi, {n}! Which path do we start with?',
    'pathway.sub':              'Pick one to get started. You can always switch or add more paths later.',
    'pathway.sub.spark':        'These paths are built for the Spark level (ages 4–6). Explore STEAM through play and curiosity!',
    'pathway.sub.explorer':     'These paths are built for the Explorer level (ages 7–9). Dive deeper into science and creativity!',
    'pathway.sub.builder':      'These paths are built for the Builder level (ages 10–12). Learn to think like a researcher and engineer!',
    'pathway.sub.challenger':   'These paths are built for the Challenger level (ages 13–16). Tackle the big questions in science and technology!',
    'pathway.level.1':          'Beginner',
    'pathway.level.2':          'Intermediate',
    'pathway.level.3':          'Advanced',
    'pathway.lessons':          '{n} lessons',
    'pathway.weeks':            'About {n} weeks',
    'pathway.age':              'Age {n}',
    'pathway.footer':           'All paths include lessons with the four Sagan movements, interactive components, and downloadable worksheets.',

    // ── Child home — missing keys ───────────────────────────────────────────
    'games.label':              '🎮 Interactive games',
    'games.all':                'See all games →',

    // ── Lesson resume banner ────────────────────────────────────────────────
    'resume.progress':          'questions answered',
    'resume.continue_q':        'Continue where you left off? 🔖',
    'resume.yes':               'Continue →',
    'resume.fresh':             'Start fresh',

    // ── Subject labels (used in SubjectBadge) ──────────────────────────────
    'subject.mathematics':      'Mathematics',
    'subject.science':          'Science',
    'subject.technology':       'Technology',
    'subject.engineering':      'Engineering',
    'subject.arts':             'Arts',
    'subject.futureskills':     'Future Skills',

    // ── Landing page demo section ───────────────────────────────────────────
    'demo.tag':       'See a real lesson',
    'demo.heading':   'Try a real Good Atoms lesson',
    'demo.sub':       'Choose a subject and read movement 1 of a real lesson — no account needed.',
    'demo.move1':     'Movement 1 · Wonder',
    'demo.bridge':    'Real world:',
    'demo.locked':    '+ 3 more movements unlocked after free sign-up',
    'demo.cta':       'Start this lesson for free →',
    'demo.nocredit':  'No credit card required',

    // ── Achievement badges ──────────────────────────────────────────────────
    'badges.label':                  '🏅 Your badges',
    'badge.new':                     'New badge!',
    'badge.unlock_cta':              'Awesome! →',
    'badge.first_step.name':         'First Step',
    'badge.first_step.desc':         'You completed your first lesson. The journey begins!',
    'badge.eager_reader.name':       'Eager Reader',
    'badge.eager_reader.desc':       "You've completed 5 lessons. You're on your way!",
    'badge.knowledge_rocket.name':   'Knowledge Rocket',
    'badge.knowledge_rocket.desc':   '10 lessons done. You\'re taking off! 🚀',
    'badge.perfect_score.name':      'Perfect!',
    'badge.perfect_score.desc':      'All correct answers in one lesson. Incredible!',
    'badge.on_fire.name':            'On Fire',
    'badge.on_fire.desc':            '3 days in a row. You\'re heating up!',
    'badge.weekly_warrior.name':     'Weekly Warrior',
    'badge.weekly_warrior.desc':     '7 days in a row. A whole week of learning!',
    'badge.two_week_titan.name':     'Two-Week Titan',
    'badge.two_week_titan.desc':     '14 days in a row. You\'re unstoppable!',
    'badge.monthly_master.name':     'Monthly Master',
    'badge.monthly_master.desc':     '30 days in a row. You\'re a legend!',
    'badge.explorer.name':           'Explorer',
    'badge.explorer.desc':           "You've tried lessons in two different subjects!",
    'badge.path_complete.name':      'Path Complete',
    'badge.path_complete.desc':      'You finished an entire path. Impressive!',

    // ── Settings page ──────────────────────────────────────────────────────
    'settings.title':              'Settings',
    'settings.subtitle':           'Account & preferences',
    'settings.email':              'Email',
    // ── Parent dashboard ───────────────────────────────────────────────────
    'parent.board':               'Good Atoms Board',
    'parent.dashboard':           'Parent Dashboard',
    'parent.last_active':         'Last active',
    'parent.today':               'Today',
    'parent.yesterday':           'Yesterday',
    'parent.days_ago':            '{n} days ago',
    'parent.child_view':          "Child's view →",
    'parent.activity_title':      '7-day activity',
    'parent.minutes_per_day':     'minutes / day',
    'parent.subjects_title':      'Subject breakdown',
    'parent.lesson_singular':     'lesson',
    'parent.lesson_plural':       'lessons',
    'parent.pathway_title':       'Pathway progress',
    'parent.pathway_of':          'of',
    'parent.completed_title':     'Completed lessons',
    'parent.worksheet':           'Worksheet',
    'parent.add_child':           'Add child',
    'parent.settings':            'Settings',

    'continue.next_lesson':       'Next lesson →',
    'continue.explore':           'Explore more',

    'empty.title':                'More lessons on the way',
    'empty.sub':                  'We are making something new for you. Try a game meanwhile!',

    'printpacks.title':           'Print pack',
    'printpacks.subtitle':        'Weekly print packs for your child',
    'printpacks.card_title':      'Weekly print pack',
    'printpacks.card_body':       'Every Sunday we generate a PDF with the week\'s worksheets, a project card, dinner table questions and a parent briefing. Available on Premium.',
    'printpacks.upgrade':         'Upgrade to Premium',
    'printpacks.back':            '← Back',
    'parent.upgrade.badge':       'Paid plan',
    'parent.upgrade.title':       'Unlock all of Good Atoms',
    'parent.upgrade.subtitle':    'Unlimited lessons · All subjects · Weekly Prnt Pack',
    'parent.upgrade.from':        'from 99 kr',
    'parent.upgrade.per_month':   '/ month',
    'parent.upgrade.feat1':       'Unlimited lessons and pathways',
    'parent.upgrade.feat2':       'Weekly Prnt Pack (PDF worksheets)',
    'parent.upgrade.feat3':       'Up to 3+ child profiles',
    'parent.upgrade.cta':         'See all plans →',
    'parent.stat.lessons':        'Lessons completed',
    'parent.stat.minutes':        'Minutes learned',
    'parent.stat.streak':         'Days in a row',
    'parent.stat.path':           'Active path',
    'day.0': 'Mon', 'day.1': 'Tue', 'day.2': 'Wed', 'day.3': 'Thu',
    'day.4': 'Fri', 'day.5': 'Sat', 'day.6': 'Sun',

    'settings.subscription':       'Subscription',
    'settings.language':           'Language',
    'settings.accessibility':      'Accessibility',
    'settings.reduce_motion':      'Reduce motion',
    'settings.reduce_motion_desc': 'Turns off animations throughout the app. Great for children with vestibular disorders, ADHD, or light sensitivity.',
    'settings.reduce_motion_on':   '✓ Animations are disabled',
    'settings.motion_on':          'Reduce motion on',
    'settings.motion_off':         'Reduce motion off',
    'settings.logout':             'Log out',
    'settings.plan.free':          'Free',
    'settings.plan.premium':       '1 child',
    'settings.plan.homeschool':    '2 children',
    'settings.plan.family':        'Family+',
    'settings.lang.no':            'Norwegian (Bokmål)',
    'settings.lang.en':            'English',

    // ── Worksheet page ─────────────────────────────────────────────────────
    'worksheet.back':       '← Back',
    'worksheet.download':   '⬇ Download PDF',
    'worksheet.print':      '🖨 Print',
    'worksheet.home':       'Home',
    'worksheet.name':       'Name:',
    'worksheet.date':       'Date:',
    'worksheet.age':        'Age {n}',
    'worksheet.family':     'Family activity',
    'worksheet.forGrownUps':    'For grown-ups',
    'worksheet.childLearned':   'What your child learned',
    'worksheet.misconceptions': 'Common misconceptions',
    'worksheet.nextTime':       'Next time',
    'worksheet.sources':    'Sources:',
    'worksheet.not_found':  'Lesson not found.',

    // ── Mastery badges (parent dashboard topic badges) ──────────────────────
    'parent.badges.title':        'Mastery Badges',
    'parent.badges.subtitle':     '{n} has mastered',
    'parent.badges.empty':        'Complete the first lesson to earn a badge!',
    'parent.badges.email_upsell': '📧 Upgrade for celebration emails',
    'parent.celebrate.title':     'Celebrate with {n}!',

    // ── Library books (parent dashboard) ────────────────────────────────────
    'parent.library.title':    '📚 Recommended Library Books',
    'parent.library.subtitle': 'Based on age and subject',
    'parent.library.free':     '✓ Free to borrow',
    'parent.library.find':     'Find →',

    // ── Consent ───────────────────────────────────────────────────────────────
    'consent.heading':          'Consent',
    'consent.body':             'Good Atoms processes your child\'s name, age, and learning data to personalise lessons.',
    'consent.privacy_link':     'Read our privacy policy',
    'consent.checkbox_before':  'I confirm I am the parent/guardian and consent to Good Atoms processing my child\'s learning data as described in our ',
    'consent.checkbox_link':    'privacy policy',
    'consent.checkbox_after':   '.',
    'consent.checkbox':         'I confirm I am the parent/guardian and consent to Good Atoms processing my child\'s learning data as described in our privacy policy.',
    'consent.required':         'You must consent to continue.',

    // ── Session timeout ──────────────────────────────────────────────────────
    'session.warning':          'Still there? Your session will expire in {n} minutes for security.',
    'session.stay':             'Stay logged in',

    // ── Undring / Wonder (content section, formerly "Blog") ────────────────
    'blog.title':               'Wonder',
    'blog.hero':                'Wonder — because every great discovery starts with a question',
    'blog.subtitle':            'STEAM learning, science, creativity, and digital tips for parents. From Good Atoms.',
    'blog.all':                 'All',
    'blog.featured':            'Featured',
    'blog.no_posts':            'No articles yet. Come back soon!',
    'blog.read_time':           'min read',
    'blog.also_read':           'Also read',
    'blog.back':                '← Back to Wonder',
    'blog.not_found':           'Article not found',
    'blog.cta_title':           'Ready to ignite curiosity?',
    'blog.cta_body':            'Good Atoms is STEAM learning that starts with wonder. Try free — no credit card required.',
    'blog.cta_button':          'Start free today',
    'blog.faq':                 'FAQ',
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// Hook
// ─────────────────────────────────────────────────────────────────────────────

export function useT() {
  const { lang, setLang } = useLangStore();

  /** Translate a key, with optional {n} interpolation */
  const t = (key: string, n?: number | string): string => {
    const str = TRANSLATIONS[lang][key] ?? TRANSLATIONS['no'][key] ?? key;
    if (n !== undefined) return str.replace('{n}', String(n));
    return str;
  };

  return { t, lang, setLang };
}
